import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DernieresInfos from './DernieresInfos';

import HomeAg from './HomeAg'
import HomeBtf from './HomeBtf';



class Home extends React.Component {
  state = {
    encoursProduits: [],
    encoursEnseigne: []

  }



  getData(aArray) {
    let i = 0
    let autreValue = 0
    const newArray = []
    aArray.forEach(element => {
      i++;
      if (i <= 4) {
        newArray.push(element)
      } else {
        autreValue += element.value
      }

    })
    if (autreValue !== 0)
      newArray.push({ value: autreValue, name: 'Autres' })


    


    return newArray
  }


  render() {
    

    return (

      <div className="section">
        <div className="top-icon-box position-relative">
          <div className="container position-relative">

                  <DernieresInfos/>
               
            {
              this.props.url==='btf' ?
                <HomeBtf />
              : this.props.url==='autogestion' || this.props.url==='autogestionch' ?
                <HomeAg/>
              :null
            }
          </div>
        </div>
      </div >
    )
  }

}

const mapStateToProps = (state) => {
  return ({
    serverConfigLoaded: state.server.initialized,
    clients: state.authentication.clients,
    currentClient: state.authentication.currentClient,
    JWTToken: state.authentication.JWTToken,
    apiUrl: state.server.apiUrl,
    encoursProduits: state.app.encoursProduits,
    encoursEnseigne: state.app.encoursEnseigne,
    nomCommercial: state.app.nomCommercial,
    telCommercial: state.app.telCommercial,
    plafond: state.app.plafond,
    emailCommercial: state.app.emailCommercial,
    url: state.app.url,
    parrain: state.app.parrain
  })
}

Home.propTypes = {
  dispatch: PropTypes.func,
  clients: PropTypes.array,
  apiUrl: PropTypes.string,
  JWTToken: PropTypes.string,
  currentClient: PropTypes.object,
  encoursProduits: PropTypes.array,
  encoursEnseigne: PropTypes.array,
  nomCommercial: PropTypes.string,
  telCommercial: PropTypes.string,
  plafond: PropTypes.number || PropTypes.string,
  emailCommercial: PropTypes.string,
  url: PropTypes.string,
  parrain: PropTypes.string
};

export default connect(mapStateToProps)(Home);
